/** Only the newest unanswered clarification may change the decision state. */
export function isClarificationCompleted(turnIndex: number, turnCount: number): boolean {
  return turnIndex >= 0 && turnIndex < turnCount - 1;
}
